import { environment } from "../../../environments/environment";

export const forgotPasswordTemplate = `<!DOCTYPE html>
<html lang="de">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Passwort festlegen - Aims</title>
    <style>
        /* CLIENT-SPECIFIC STYLES */
        body, table, td, a { -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }
        table, td { mso-table-lspace: 0pt; mso-table-rspace: 0pt; }
        img { -ms-interpolation-mode: bicubic; }

        /* RESET STYLES */
        img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; }
        table { border-collapse: collapse !important; }
        body { height: 100% !important; margin: 0 !important; padding: 0 !important; width: 100% !important; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; }

        /* iOS BLUE LINK REMOVAL */
        a[x-apple-data-detectors] {
            color: inherit !important;
            text-decoration: none !important;
            font-size: inherit !important;
            font-family: inherit !important;
            font-weight: inherit !important;
            line-height: inherit !important;
        }

        /* MEDIA QUERIES */
        @media screen and (max-width: 600px) {
            .w-full { width: 100% !important; }
            .p-mobile { padding-left: 20px !important; padding-right: 20px !important; }
            .h-auto { height: auto !important; }
            .text-lg { font-size: 18px !important; line-height: 26px !important; }
        }
    </style>
</head>
<body style="margin: 0; padding: 0; background-color: #f1f5f9;">

    <!-- CENTER WRAPPER -->
    <table border="0" cellpadding="0" cellspacing="0" width="100%">
        <tr>
            <td align="center" style="background-color: #f1f5f9; padding: 40px 0;">
                
                <!-- EMAIL CONTAINER (Max Width 600px) -->
                <table border="0" cellpadding="0" cellspacing="0" width="600" class="w-full" style="background-color: #ffffff; overflow: hidden; box-shadow: 0 2px 5px rgba(0,0,0,0.05);">
                    
                    <!-- HEADER (Branded Blue) -->
                    <tr>
                        <td align="center" style="background-color: #00569c; padding: 35px 20px;">
                            <!-- Logo / Icon Placeholder -->
                            <img src="{{logoUrl}}" alt="Aims Logo" width="100" style="display: block; color: #ffffff; font-family: sans-serif; font-size: 20px; font-weight: bold;">
                        </td>
                    </tr>

                    <!-- BODY CONTENT -->
                    <tr>
                        <td class="p-mobile" style="padding: 40px 40px 20px 40px;">
                            
                            <!-- Headline -->
                            <h1 style="color: #007bff; font-size: 24px; margin: 0 0 20px 0; font-weight: 700; font-family: Arial, sans-serif;">
                                Passwort festlegen
                            </h1>

                            <!-- Salutation -->
                            <p style="color: #333333; font-size: 16px; line-height: 24px; margin: 0 0 20px 0;">
                                Hallo {{person.FirstName}} {{person.LastName}},
                            </p>

                            <!-- Main Intro -->
                            <p style="color: #333333; font-size: 16px; line-height: 24px; margin: 0 0 20px 0;">
                                Willkommen bei <strong>Aims</strong>! Um Ihren Zugang sicher zu gestalten, können Sie jetzt Ihr Passwort über einen geschützten Link festlegen.
                            </p>

                            <!-- Username Display -->
                            <p style="color: #333333; font-size: 16px; line-height: 24px; margin: 0 0 20px 0;">
                                Ihr Benutzername ist <strong>{{person.username}}</strong>
                            </p>

                            <!-- Instruction -->
                            <p style="color: #333333; font-size: 16px; line-height: 24px; margin: 0 0 25px 0;">
                                Klicken Sie einfach auf den folgenden Button, um Ihr Passwort festzulegen und Ihr Konto zu aktivieren:
                            </p>

                            <!-- CTA BUTTON CENTERED -->
                            <table border="0" cellpadding="0" cellspacing="0" width="100%">
                                <tr>
                                    <td align="center" style="padding-bottom: 25px;">
                                        <a href="{{landingPageUrl}}" target="_blank" style="background-color: #007bff; color: #ffffff; display: inline-block; font-size: 16px; font-weight: bold; line-height: 48px; text-align: center; text-decoration: none; width: 220px; border-radius: 4px; -webkit-text-size-adjust: none; font-family: Arial, sans-serif;padding: 10px 20px;">
                                            Passwort festlegen
                                        </a>
                                    </td>
                                </tr>
                            </table>

                            <!-- ADDITIONAL DETAILS -->
                            <div style="margin-top: 10px;">
                                <p style="color: #555555; font-size: 14px; line-height: 22px; margin: 0 0 10px 0;">
                                    Dieser Link ist aus Sicherheitsgründen nur 24 Stunden gültig.
                                </p>
                                <p style="color: #555555; font-size: 14px; line-height: 22px; margin: 0 0 10px 0;">
                                    Ihr Passwort sollte mindestens 8 Zeichen lang sein und eine Kombination aus Großbuchstaben, Kleinbuchstaben, Zahlen und Sonderzeichen enthalten.
                                </p>
                                <p style="color: #555555; font-size: 14px; line-height: 22px; margin: 0 0 30px 0;">
                                    Sollte der Link abgelaufen sein, kontaktieren Sie bitte unseren Support unter <a href="mailto:${environment.Email.systemEmail}" style="color: #007bff; text-decoration: underline;">${environment.Email.systemEmail}</a>.
                                </p>
                            </div>

                            <!-- SIGN OFF -->
                            <p style="color: #333333; font-size: 16px; line-height: 24px; margin: 0;">
                                Mit freundlichen Grüßen,<br>
                                Ihr Aims-Team
                            </p>
                        </td>
                    </tr>
                    
                    <!-- Spacer at bottom of white card -->
                    <tr>
                        <td height="40" style="font-size: 0; line-height: 0;">&nbsp;</td>
                    </tr>

                </table>
                <!-- END EMAIL CONTAINER -->

                <!-- FOOTER (Outside white card) -->
                <table border="0" cellpadding="0" cellspacing="0" width="600" class="w-full">
                    <tr>
                        <td align="center" style="padding: 20px 0;">
                            <p style="color: #888888; font-size: 12px; line-height: 18px; margin: 0; text-align: center; font-family: Arial, sans-serif;">
                                Diese E-Mail wurde automatisch generiert. Antworten Sie bitte nicht darauf.
                            </p>
                        </td>
                    </tr>
                </table>

            </td>
        </tr>
    </table>

</body>
</html>`;
